export * from './useGetNotificationPermissions'
export * from './useNotificationHandler'

type UseGetNotificationPermissionsMobile = typeof import('./useGetNotificationPermissions')
type UseGetNotificationPermissionsWeb = typeof import('./useGetNotificationPermissions.web')

true satisfies UseGetNotificationPermissionsMobile extends UseGetNotificationPermissionsWeb
  ? UseGetNotificationPermissionsWeb extends UseGetNotificationPermissionsMobile
    ? true
    : false
  : false

type UseNotificationHandlerMobile = typeof import('./useNotificationHandler')
type UseNotificationHandlerWeb = typeof import('./useNotificationHandler.web')

true satisfies UseNotificationHandlerMobile extends UseNotificationHandlerWeb
  ? UseNotificationHandlerWeb extends UseNotificationHandlerMobile
    ? true
    : false
  : false
